import script from "./QrPage.vue?vue&type=script&setup=true&lang=js"
export * from "./QrPage.vue?vue&type=script&setup=true&lang=js"

import "./QrPage.vue?vue&type=style&index=0&id=6780ab64&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6780ab64"]])

export default __exports__